import {MappableData} from './MappableData';
import { MappedDataItem } from './MappedDataItem';
import {ReportDataService} from '../../report-data.service';

import {environment} from '../../../environments/environment';

export class ActualCostHourDataMap extends MappableData {

  constructor(protected reportService: ReportDataService) {
    super(reportService, 'Actual Cost Hour Data');
    this.mappedData.push(new MappedDataItem(environment.ACTUAL_COST_HOUR_DATA, 'Actuals To Date (Dollars)', 'Value_Dollars'));
    this.mappedData.push(new MappedDataItem(environment.ACTUAL_COST_HOUR_DATA, 'Actuals To Date (Hours)', 'Value_Hours'));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data/ActualCostHourDataMap.ts